import React, { useState } from 'react';
import DataTable from '../components/common/DataTable';
import FormField from '../components/common/FormField';
import { formatDateTime } from '../utils/formatters';
import './AuditLogPage.css';

const AuditLogPage = () => {
  const [dateRange, setDateRange] = useState({ start: '', end: '' });

  const mockLogs = [
    { id: '1', timestamp: '2023-10-25T10:00:00Z', user: 'admin@test.com', action: 'VIEW_REPORT', resource: 'Application 123', ipAddress: '192.168.1.1' },
    { id: '2', timestamp: '2023-10-25T11:30:00Z', user: 'verifier@test.com', action: 'APPROVE_VERIFICATION', resource: 'Verification 456', ipAddress: '10.0.0.5' }
  ];

  const columns = [
    { header: 'Timestamp', accessor: 'timestamp', render: (row) => formatDateTime(row.timestamp) },
    { header: 'User', accessor: 'user' },
    { header: 'Action', accessor: 'action' },
    { header: 'Resource', accessor: 'resource' },
    { header: 'IP Address', accessor: 'ipAddress' }
  ];

  return (
    <div className="audit-log-page">
      <div className="audit-log__header">
        <h1>Audit Log</h1>
        <button className="btn-secondary">Export to CSV</button>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="audit-log__filters">
            <FormField label="Start Date" name="start" type="date" value={dateRange.start} onChange={(e) => setDateRange({...dateRange, start: e.target.value})} />
            <FormField label="End Date" name="end" type="date" value={dateRange.end} onChange={(e) => setDateRange({...dateRange, end: e.target.value})} />
          </div>
          
          <DataTable columns={columns} data={mockLogs} />
        </div>
      </div>
    </div>
  );
};

export default AuditLogPage;
